import { render, staticRenderFns } from "./data-grid-simple.vue?vue&type=template&id=8aef026c&"
import script from "./data-grid-simple.js?vue&type=script&lang=js&"
export * from "./data-grid-simple.js?vue&type=script&lang=js&"
import style0 from "./data-grid-simple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports